<template>
<div id="app" style="height: 100%;">
    <div id="nav">

    </div>
    <router-view />
</div>
</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.css'
export default {
    watch: {
        'navigator.onLine'() {
            console.log("navigator", navigator);
            console.log("navigator.onLine", navigator.onLine);
            // if (!navigator.onLine) {
            //     alert("인터넷 연결이 원할하지 않습니다.");
            //     this.$router.push('/admin/login')
            //     localStorage.removeItem('accessToken')
            //     localStorage.removeItem('regid')
            // }
        }
    }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
